(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmOpportunityStatusDeleteController',CrmOpportunityStatusDeleteController);

    CrmOpportunityStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'CrmOpportunityStatus'];

    function CrmOpportunityStatusDeleteController($uibModalInstance, entity, CrmOpportunityStatus) {
        var vm = this;

        vm.crmOpportunityStatus = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CrmOpportunityStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
